import { render } from "./matching-list-cards.vue?vue&type=template&id=1b544f3c&scoped=true&ts=true"
import script from "./matching-list-cards.vue?vue&type=script&lang=ts"
export * from "./matching-list-cards.vue?vue&type=script&lang=ts"

import "./matching-list-cards.vue?vue&type=style&index=0&id=1b544f3c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b544f3c"]])

export default __exports__